import style from './ArticleModule.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { ArticleAssembly } from 'src/api/contentful/contentTypes.cloverdotcom';
import { getField } from 'src/utils/EntryUtil';

import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { TextStack } from '../TextStack/TextStack';

interface IArticleModuleProps extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<ArticleAssembly>;
}

const ArticleModule: React.FC<IArticleModuleProps> = ({ entry, className, ...props }) => (
  <TextStack
    entry={getField(entry, 'topic')}
    tagName="section"
    className={cx(className, style.articleContainer)}
    blurbClassName={style.articleText}
    linkClassName={style.contentLink}
    {...props}
  />
);

const Wrapped = applyEntryDataAttributes(ArticleModule);

export { Wrapped as ArticleModule };
